export default __webpack_public_path__ + "static/media/img5.54c1d502.jpg";